import {
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  OutlinedInput,
} from "@mui/material";
import { sortBy } from "lodash";
import { TagListContext } from "../../common/contexts/TagListContext";
import { useEffect, useContext, useState } from "react";

const SelectTagStandard = ({ tagStandard, setTagStandard }) => {
  const availableTagLists = useContext(TagListContext);
  const [tagLists, setTagLists] = useState([
    { Name: "Loading...", TCTagListId: -1 },
  ]);

  useEffect(() => {
    if (availableTagLists.TagLists && availableTagLists.TagLists.length > 0) {
      setTagLists(
        availableTagLists.TagLists.filter((tagList) => tagList.IsTagStandard)
      );
    }
  }, [availableTagLists]);

  return (
    <FormControl sx={{ width: 200 }}>
      <InputLabel id='tag-standard-label'>Tag Standard</InputLabel>
      <Select
        value={tagStandard}
        onChange={(e) => {
          setTagStandard(e.target.value);
          localStorage.setItem("tagStandard", e.target.value);
        }}
        size={"small"}
        input={<OutlinedInput label='Tag Standard' />}>
        {sortBy(tagLists, (tagStandardEntry) => {
          return tagStandardEntry.Name;
        }).map((tagStandardEntry, index) => {
          return (
            <MenuItem key={index} value={tagStandardEntry.TCTagListId}>
              {tagStandardEntry.Name}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};

export default SelectTagStandard;
